// Branches
export const ADD_BRANCH = 'ADD_BRANCH';
export const REMOVE_BRANCH = 'REMOVE_BRANCH';

// Bookings
export const ADD_BOOKING = 'ADD_BOOKING';
export const DELETE_BOOKING = 'DELETE_BOOKING';
export const ACTION_BOOKING = 'ACTION_BOOKING';
export const ACTION_BOOKING_ID = 'ACTION_BOOKING_ID';

// Application
export const ADD_DATE = 'ADD_DATE';
export const ALERT = 'ALERT';
export const LOADING = 'LOADING';
export const ERROR = 'ERROR';
export const SET_ALL_PRODUCTS = 'SET_ALL_PRODUCTS';
